document.addEventListener('click', async (e) => {
  const closeBtn = e.target.closest('share-button .share-button__close');
  if (closeBtn) {
    e.preventDefault();

    const root = closeBtn.closest('share-button');
    if (!root) return;

    const details = root.querySelector('details');
    const message = root.querySelector('[id^="ShareMessage"]');

    if (message) {
      message.classList.add('hidden');
      message.textContent = '';
    }

    closeBtn.classList.add('hidden');

    if (details) {
      details.open = false;
    }

    return;
  }

  const copyBtn = e.target.closest('share-button .share-button__copy');
  if (copyBtn) {
    e.preventDefault();

    const root = copyBtn.closest('share-button');
    if (!root) return;

    const input = root.querySelector('input[id^="ShareUrl-"]');
    const message = root.querySelector('[id^="ShareMessage"]');
    const closeBtn = root.querySelector('.share-button__close');

    if (!input) return;

    try {
      await navigator.clipboard.writeText(input.value);

      if (message) {
        message.classList.remove('hidden');
        message.textContent =
          window.accessibilityStrings?.shareSuccess || 'リンクをコピーしました';
      }

      if (closeBtn) {
        closeBtn.classList.remove('hidden');
      }
    } catch (err) {
      console.error(err);
    }

    return;
  }

  const btn = e.target.closest('share-button .share-button__button');
  if (!btn) return;
  if (btn.tagName.toLowerCase() === 'summary') return;

  const root = btn.closest('share-button');
  if (!root) return;
  if (btn !== root.querySelector(':scope > .share-button__button')) return;

  const input = root.querySelector('input[id^="ShareUrl-"]');
  const url = input?.value || window.location.href;

  if (navigator.share) {
    e.preventDefault();
    try {
      await navigator.share({
        title: document.title,
        url: url
      });
      return;
    } catch (err) {
      if (err && err.name === 'AbortError') return;
    }
  }

  const details = root.querySelector('details');
  if (details) {
    const message = root.querySelector('[id^="ShareMessage"]');
    const closeBtn = root.querySelector('.share-button__close');

    if (message) {
      message.classList.add('hidden');
      message.textContent = '';
    }

    if (closeBtn) {
      closeBtn.classList.add('hidden');
    }

    details.hidden = false;
    details.open = true;

    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }
});


document.addEventListener('click', async (e) => {
  const copyBtn = e.target.closest('share-button .share-button__copy');
  if (copyBtn) {
    e.preventDefault();

    const root = copyBtn.closest('share-button');
    if (!root) return;

    const input = root.querySelector('input[id^="ShareUrl-"]');
    const message = root.querySelector('[id^="ShareMessage"]');
    const closeBtn = root.querySelector('.share-button__close');

    if (!input) return;

    try {
      await navigator.clipboard.writeText(input.value);

      if (message) {
        message.classList.remove('hidden');
        message.textContent =
          window.accessibilityStrings?.shareSuccess || 'リンクをコピーしました';
      }

      if (closeBtn) {
        closeBtn.classList.remove('hidden');
      }
    } catch (err) {
      console.error(err);
    }

    return;
  }
  
  const btn = e.target.closest('share-button .share-button__button');
  if (!btn) return;
  if (btn.tagName.toLowerCase() === 'summary') return;

  const root = btn.closest('share-button');
  if (!root) return;
  if (btn !== root.querySelector(':scope > .share-button__button')) return;

  // share URL は既存の input から拾う（Dawnのshare-buttonの構造を利用）
  const input = root.querySelector('input[id^="ShareUrl-"]');
  const url = input?.value || window.location.href;

  // Web Share API が使える端末ならネイティブ共有を優先
  if (navigator.share) {
    e.preventDefault();
    try {
      await navigator.share({
        title: document.title,
        url: url
      });
      return;
    } catch (err) {
      // ユーザーがキャンセルした場合は何もしない
      if (err && err.name === 'AbortError') return;
      // 失敗したら下のフォールバックへ
    }
  }

  // フォールバック: 既存の details（リンクコピーUI）を開く
  const details = root.querySelector('details');
  if (details) {
    details.hidden = false;
    details.open = true;
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }
});
